import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

// Async thunk for getting animal historic event by ID
export const getAnimalHistoricEventById = createAsyncThunk(
  "animalHistoricEvent/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`/api/zival/zgodovina/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// Async thunk for getting paginated animal historic events
export const getAnimalHistoricEventPage = createAsyncThunk(
  "animalHistoricEvent/getPage",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        "/api/zival/zgodovina/page",
        undefined,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// Slice
const animalHistoricEventSlice = createSlice({
  name: "animalHistoricEvent",
  initialState: {
    current: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Get by ID
    builder
      .addCase(getAnimalHistoricEventById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAnimalHistoricEventById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(getAnimalHistoricEventById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Get paginated list
    builder
      .addCase(getAnimalHistoricEventPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAnimalHistoricEventPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getAnimalHistoricEventPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default animalHistoricEventSlice.reducer;
